import SocialCampaignToken from '@apps/campaigns/admin/tokens/campaign/social'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Social Campaigns)',
  collection: {
    endpoint: `/api/admin/truevail/agency/social_batches/${props.social_batch.id}/publishings/${props.publishing.id}/social_campaigns`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Social Campaign)', key: 'advisor.title', sort: 'advisor', primary: true, format: (social_campaign) => (
        <SocialCampaignToken social_campaign={ social_campaign } />
      ) }
    ],
    defaultSort: { key: 'post_at', order: 'desc' },
    empty: {
      svg: 'messages_square',
      title: 't(No Social Campaigns)',
      text: 't(There are no published social campaigns for this advisor)'
    },
    entity: 'social campaign',
    onClick: (record) => context.router.push(`/admin/truevail/agency/advisors/${props.publishing.subscription.advisor.id}/social_campaigns/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
